import {
  AH_VERIFICATION_LIST_SUCCESS,
  GET_VERIFIED_AH_DETAIL_SUCCESS,
  GET_VERIFIED_AH_LIST_SUCCESS,
  SET_ACTIVE_SYNC_DETAILS_DATA,
  SET_FILTER_DATA,
  SET_SYNC_DETAILS_FILTER_DATA,
  SET_VERIFICATION_JOB_LOADING,
} from "./actionTypes";

const INITIAL_STATE = {
  verificationJobLoading: false,
  ahVerificationJobs: {
    ahVerificationJobList: [],
  },
  verifiedAHData: {
    verifiedAHList: [],
  },
  verfiedAHDetail: null,
  filterData: {
    currentPage: 1,
    status: "",
    dates: null,
  },
  syncDetailsFilterData: {
    currentPage: 1,
  },
  activeSyncDetailsData: {},
};

const syncLogsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_VERIFICATION_JOB_LOADING:
      return {
        ...state,
        verificationJobLoading: action?.payload,
      };
    case AH_VERIFICATION_LIST_SUCCESS:
      return {
        ...state,
        verificationJobLoading: false,
        ahVerificationJobs: {
          ...state.ahVerificationJobs,
          ahVerificationJobList: action?.payload?.jobs,
          currentPage: action?.payload?.currentPage,
          totalJobs: action?.payload?.totalJobs,
        },
      };
    case GET_VERIFIED_AH_LIST_SUCCESS:
      return {
        ...state,
        verificationJobLoading: false,
        verifiedAHData: {
          ...state.verifiedAHData,
          verifiedAHList: action?.payload?.accountHolders,
          currentPage: action?.payload?.pagination?.currentPage,
          totalPages: action?.payload?.pagination?.totalPages,
          totalData: action?.payload?.pagination?.totalAccountHolders,
        },
      };
    case GET_VERIFIED_AH_DETAIL_SUCCESS:
      return {
        ...state,
        verificationJobLoading: false,
        verfiedAHDetail: action?.payload,
      };
    case SET_FILTER_DATA:
      return {
        ...state,
        filterData: {
          ...state?.filterData,
          ...action?.payload,
        },
      };
    case SET_SYNC_DETAILS_FILTER_DATA:
      return {
        ...state,
        syncDetailsFilterData: {
          ...state?.syncDetailsFilterData,
          ...action?.payload,
        },
      };
    case SET_ACTIVE_SYNC_DETAILS_DATA:
      return {
        ...state,
        activeSyncDetailsData: {
          ...action?.payload,
        },
      };
    default:
      return state;
  }
};

export default syncLogsReducer;
